var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraRefresh = function SvgCameraRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.185 8.702a7 7 0 0 0-12.9 1.458.75.75 0 1 1-1.446-.401 8.5 8.5 0 0 1 15.679-1.746l.534-1.631a.75.75 0 1 1 1.425.466l-1.1 3.36a.75.75 0 0 1-.945.48l-3.36-1.1a.75.75 0 1 1 .466-1.425l1.647.539ZM4.515 16.061l-.533 1.631a.75.75 0 0 1-1.426-.466l1.1-3.36a.75.75 0 0 1 .946-.48l3.36 1.1a.75.75 0 1 1-.467 1.425l-1.647-.539a7 7 0 0 0 12.901-1.458.75.75 0 1 1 1.445.401 8.5 8.5 0 0 1-15.679 1.746Z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};
export default SvgCameraRefresh;